export default {
    state: {
        
    },
    mutations: {
    },
    actions: {
        getBills({commit}, payload){
            let url = '/plan-subscriptions';
            return new Promise((resolve, reject)=>{
                window.axios.get(url).then(response=>{
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        changeSubscriptionPlan({commit}, payload){
            let url = '/plan-subscriptions/change';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then(response=>{
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        cancelSubscriptionPlan({commit}, payload){
            let url = '/plan-subscriptions/cancel';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then(response=>{
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        paySubscriptionBill({commit}, payload){
            let url = '/plan-subscriptions/bills/pay';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
    }
}